import API from '.';
import serviceUrls from 'src/constants/serviceUrls';

export const login = (email, password) => {
  const basicAuth = ('Basic ' + btoa(email + ':' + password)).trim();
  return API({
    headers: { authorization: basicAuth },
  })
    .post(serviceUrls.LOGIN_SERVICE, {})
    .then(res => ({ status: res.status, data: res.data }))
    .catch(err => toErrorResponse(err))
    .then(res => res);
};

//users/validate
export const userValidate = () => {
  return API({
    headers: {},
  })
    .post(serviceUrls.USER_VALIDATE_SERVICE, {})
    .then(res => ({ status: res.status, data: res.data }))
    .catch(err => toErrorResponse(err))
    .then(res => res);
};

export const getSSORedirectUrl = () => {
  return API({
    headers: {},
  })
    .post(serviceUrls.GET_SSO_REDIRECT_URL, {})
    .then(res => ({ status: res.status, data: res.data }))
    .catch(err => toErrorResponse(err))
    .then(res => res);
};

//users/logout
export const userLogout = payload => {
  return API({
    headers: {},
  })
    .post(serviceUrls.LOGOUT_SERVICE, { data: payload })
    .then(res => ({ status: res.status, data: res.data }))
    .catch(err => toErrorResponse(err))
    .then(res => res);
};

export const sendSelectedUserRole = payload => {
  return API({
    headers: {},
  })
    .post(serviceUrls.LOGIN_SELECT_ROLE_SERVICE, { data: payload })
    .then(res => ({ status: res.status, data: res.data }))
    .catch(err => toErrorResponse(err))
    .then(res => res);
};

const toErrorResponse = err => {
  let res = { status: null, error: null };
  if (err.response) {
    res.status = err.response.status;
    if (err.response.data && err.response.data.error) {
      res.error = { message: err.response.data.error };
      return res;
    } else if (err.response.data && err.response.data.title) {
      res.error = { message: err.response.data.title };
      return res;
    }
  }
  res.error = { message: err.message || 'Unknown error occurred.' };
  return res;
};
